import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

export default function PaymentSuccessBanner() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5); // 5-second countdown

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/training"); // Redirect when countdown ends
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup
  }, [navigate]);

  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "20px",
          margin: "20px",
          backgroundColor: "#e6ffed",
          color: "#1b5e20",
          border: "1px solid #a3d9a5",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <h1 style={{ fontSize: "1.8rem", marginBottom: "10px" }}>
          🎉 Payment Successful!
        </h1>
        <p style={{ fontSize: "1rem" }}>
          Thank you! Your booking is confirmed.
        </p>
        <p style={{ fontSize: "0.9rem", marginTop: "10px", fontStyle: "italic" }}>
          Redirecting to Training page in {countdown} second{countdown > 1 ? "s" : ""}...
        </p>
      </div>
    </>
  );
}
